













































































































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import {ActiveInject} from "@/support/reactive"
import {Candidate} from '@/jds';
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"
import moment from "moment"

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 * @changelog 4.7.5 Add support for `highlight` and add `additionalForm` to the candidate data.
 * @changelog 4.7.6 Add support for `additionalFormState`, replacing the previous counter.
 * @changelog 4.8.5 Add tooltips on tag bars (#7).
 * @changelog 4.8.6 Improve shadow animation repaint performance.
 * @changelog 4.11.0 Add score summary popup.
 * @changelog 5.9.0 Add freshness indicators.
 * @changelog 5.9.1 Switch to 72 hours and 120 hours for warn and stale states, respectively.
 * @changelog 6.8.6 Add support for `candidateAnsweredAdditionalQuestion`.
 */
@Component({
    components: {JdhSneakPeek, JdsGlyph, JdsIcon}
})
export default class JdsCandidateBubble extends Vue {
    @ActiveInject({from: 'jds.pipeline.card.selected', default: false}) selected!: boolean
    @Prop() candidate: typeof Candidate

    @Prop({type: Boolean, default: false}) highlight!: boolean

    /**
     * Enable this to show the "staleness indicator".
     */
    @Prop({type: Boolean, default: false}) showFreshness!: boolean

    @Prop({type: Boolean, default: false}) candidateAnsweredAdditionalQuestion!: boolean

    // thresholds are in minutes, based on time since candidate entry.
    staleThreshold = 5 * 24 * 60 // candidate is stale after 5 days
    warnThreshold = 3 * 24 * 60 // candidate is warn after 3 days

    @Ref() scoreSummaryEl!: HTMLElement
    @Ref() additionalAnswersEl!: HTMLElement

    showScoreSummary = false
    showAdditionalAnswers = false

    get classes() {
        return {
            'jdsc-candidate-bubble--selected': this.selected,
            'jdsc-candidate-bubble--highlight': this.highlight,
            'jdsc-candidate-bubble--freshness-stale': this.isStale,
            'jdsc-candidate-bubble--freshness-warn': this.isWarn,
            'jdsc-candidate-bubble--freshness-fresh': this.isFresh,
        }
    }

    get entryTimestampClasses() {
        return {
            'jdsc-candidate-bubble__entry--stale': this.isStale,
            'jdsc-candidate-bubble__entry--warn': this.isWarn,
            'jdsc-candidate-bubble__entry--fresh': this.isFresh,
        }
    }

    get isStale() {
        if (this.showFreshness && this.candidate.enteredAt) {
            return moment(this.candidate.enteredAt).isBefore(moment().subtract(this.staleThreshold, 'minutes'))
        } else {
            return false
        }
    }

    get isWarn() {
        if (this.showFreshness && this.candidate.enteredAt) {
            return moment(this.candidate.enteredAt).isBefore(moment().subtract(this.warnThreshold, 'minutes'))
                && moment(this.candidate.enteredAt).isAfter(moment().subtract(this.staleThreshold, 'minutes'))
        } else {
            return false
        }
    }

    get isFresh() {
        if (this.showFreshness && this.candidate.enteredAt) {
            return moment(this.candidate.enteredAt).isAfter(moment().subtract(this.warnThreshold, 'minutes'))
        } else {
            return false
        }
    }

    get staleness() {
        if (!this.showFreshness) return 0

        return Math.min(moment().diff(this.candidate.enteredAt, 'minutes') / (this.staleThreshold * 0.01), 100)
    }


}
